import { render } from "./fast-login.vue?vue&type=template&id=6048fea3&scoped=true&ts=true"
import script from "./fast-login.vue?vue&type=script&lang=ts"
export * from "./fast-login.vue?vue&type=script&lang=ts"

import "./fast-login.vue?vue&type=style&index=0&id=6048fea3&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6048fea3"]])